export const XIIQuestion = [
    {
        id:1,
        title:"March 2024",
        ref:"https://tnegadge.s3.amazonaws.com/notification/questbank/2200420242.pdf"
    },
    {
        id:2,
        title:"March 2023",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2023_Mar_HSE_II.pdf"
    },
    {
        id:3,
        title:"May 2022",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2022_May_HSE_II.pdf"
    },
    {
        id:4,
        title:"May 2021",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2021_May_HSE_II.pdf"
    }
];

export const XIQuestion = [
    {
        id:1,
        title:"March 2024",
        ref:"https://tnegadge.s3.amazonaws.com/notification/questbank/1200420241.pdf"
    },
    {
        id:2,
        title:"March 2023",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2023_Mar_HSE_I.pdf"
    },
    {
        id:3,
        title:"May 2022",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2022_May_HSE_I.pdf"
    },
    {
        id:4,
        title:"May 2021",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2021_May_HSE_I.pdf"
    }
];

export const XQuestion = [
    {
        id:1,
        title:"March 2024",
        ref:"https://tnegadge.s3.amazonaws.com/notification/questbank/1713432060.pdf"
    },
    {
        id:2,
        title:"March 2023",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2023_Mar_SSLC.pdf"
    },
    {
        id:3,
        title:"May 2022",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2022_May_SSLC.pdf"
    },
    {
        id:4,
        title:"May 2021",
        ref:"https://tnegadge.s3-ap-south-1.amazonaws.com/notification/questbank/2021_SSLC.pdf"
    }
];
